<template>
    <CRow>
        <CCol col="12" lg="12">
            <CCard>
                <CCardBody>
                    <form
                        @submit.prevent="createRecord('VEHICLES', { name:name, phone:phone, email:email, municipality: uppercaseText(municipality), comments: comments, size: { id: vehicleTypeSizeId}, state: { id: state_id }, })"
                        method="post"
                    >
                        <h3 v-if="isEditing">
                            {{ $t('button.edit') }} {{ $t('vehicles.title') }}
                        </h3>
                        <h3 v-else>{{ $t('button.create') }} {{ $t('vehicles.title') }}</h3>
                        <br>
                        <CRow>
                            <CCol col="12" lg="12">
                                <CRow>
                                    <CCol col="10" lg="10">
                                        <CInput 
                                            :placeholder="$t('typeVehicles.placeholder')" 
                                            :label="$t('typeVehicles.title')" 
                                            v-model="typeVehicleSize" 
                                            type="text" 
                                            required
                                            readonly
                                        ></CInput>
                                    </CCol>
                                    <CCol col="2" lg="2" style="margin-top:20px">
                                        <CButton color="warning" class="m-2" @click="showDetail = true">
                                            <CIcon :content="updateIcon" /> {{ $t('button.options') }}
                                        </CButton>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.municipality.placeholder')" 
                                    :label="$t('fields.municipality.label')" 
                                    :value.sync="municipality" 
                                    type="text" 
                                    @input="onUppercaseInput('municipality', $event)"
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                    <CSelect 
                                        :placeholder="$t('fields.state.placeholder')" 
                                        :label="$t('fields.state.label')" 
                                        :options="states"
                                        :value.sync="state_id"
                                        :plain="true"
                                    ></CSelect>
                            </CCol>
                            <CCol col="12" lg="12">
                                <CTextarea 
                                    :placeholder="$t('fields.comments.placeholder')" 
                                    :label="$t('fields.comments.label')" 
                                    v-model="comments" 
                                    type="text" 
                                    required
                                ></CTextarea>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.name.placeholder')" 
                                    :label="$t('fields.name.label')" 
                                    v-model="name" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                            <CCol col="6" lg="6">
                                <div class="form-group">
                                    <label>{{ $t('fields.whatsapp.label') }}</label>
                                    <input
                                        class="form-control"
                                        :placeholder="$t('fields.whatsapp.placeholder')"
                                        :value="phone"
                                        type="text"
                                        inputmode="numeric"
                                        minlength="10"
                                        maxlength="10"
                                        pattern="[0-9]{10}"
                                        @input="onPhoneInput"
                                        required
                                    />
                                </div>
                            </CCol>
                            <CCol col="6" lg="6">
                                <CInput 
                                    :placeholder="$t('fields.email.placeholder')" 
                                    :label="$t('fields.email.label')" 
                                    v-model="email" 
                                    type="text" 
                                    required
                                ></CInput>
                            </CCol>
                       </CRow>
                        <CRow>
                            <CCol col="12" lg="12" class="text-right">
                                <CButton color="success" type="submit" class="m-2">
                                    <template v-if="isEditing">
                                        <CIcon :content="updateIcon" /> {{ $t('button.update') }}
                                    </template>
                                    <template v-else>
                                        <CIcon :content="addIcon" /> {{ $t('button.create') }}
                                    </template>
                                </CButton>
                            </CCol>
                        </CRow>
                    </form>
                </CCardBody>
            </CCard>
        </CCol>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('typeVehicles.title')"
        >
            <div>
                <CRow v-for="typeVehicle in typeVehicles" :key="typeVehicle.id" >
                    <div class="col-sm-12">
                        <label class="label-detail" style="font-weight: bold">
                            {{typeVehicle.name}}
                        </label>
                        <hr/>
                    </div>
                    <div class="col-sm-12" v-for="size in typeVehicle.sizes" 
                        :key="size.id" style="text-align: center; cursor: pointer;"
                        @click="onSelectTipeVehicleSize(typeVehicle, size)">
                        <label class="label-detail">
                            {{size.name}}
                        </label>
                    </div>
                </CRow>
            </div>
        </CModal>
    </CRow>
</template>

<script>
import axios from 'axios'
import catalog from '../../hooks/catalogs';
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
    name: 'CategoryCreate',
    mixins: [catalog],
    data() {
        return {
            updateIcon: cilSync,
            addIcon: cilPlus,
            backIcon: cilArrowLeft,
            name: null,
            states: [],
            typeVehicles: [],
            showDetail: false,
            typeVehicleSize: null,
            municipality: null,
            state_id: null,
            vehicleTypeSizeId: null,
            vehicleTypeId: null,
            comments: null,
            phone: null,
            email: null,
        }
    },
    methods: {
        onSelectTipeVehicleSize(vehicleTypeSize, size) {
            this.typeVehicleSize = vehicleTypeSize.name + " - " + size.name;
            this.vehicleTypeSizeId = size.id;
            this.vehicleTypeSizeId = size.id;
            this.showDetail = false;
        },
        onPhoneInput(event) {
            const normalized = this.normalizePhone(event.target.value);
            this.phone = normalized;
            event.target.value = normalized;
        },
        normalizePhone(value) {
            return String(value || "").replace(/\D/g, "").slice(0, 10);
        },
        onUppercaseInput(field, value) {
            this[field] = this.uppercaseText(value);
        },
        uppercaseText(value) {
            return String(value || "").toUpperCase();
        },
    },
    watch: {
        phone(value) {
            const normalized = this.normalizePhone(value);
            if (value !== normalized) {
                this.phone = normalized;
            }
        },
        municipality(value) {
            const normalized = this.uppercaseText(value);
            if (value !== normalized) {
                this.municipality = normalized;
            }
        },
    },
    async mounted() {
        let self = this;
        const token = localStorage.getItem('token', null);

        axios.get(`user`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }
            })
            .then(response => {
                self.name = response.data.name;
                self.email = response.data.email;
                self.phone = response.data.phone;
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`type-vehicle`)
            .then(response => {
                response.data.forEach(function(record){
                    self.typeVehicles.push(record);
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`states`)
            .then(response => {
                response.data.forEach(function(record){
                    self.states.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });
    }
}
</script>
